import { TFunction } from 'i18next'
import { FormItem } from 'vnetwork-ui'

interface StepAdditionalInfoProps {
    control: any
    t: TFunction
}

/**
 * Step 4: Additional information (explanation)
 */
const StepAdditionalInfo = ({ control, t }: StepAdditionalInfoProps) => (
    <div className="space-y-4">
        <div className="grid md:grid-cols-2 gap-4">
            <FormItem
                control={control}
                name="explaination.explaination_provider"
                type="textfield"
                label={t('current_provider')}
            />

            <FormItem
                control={control}
                name="explaination.explaination_budget"
                type="number"
                label={t('expected_budget')}
            />
        </div>

        <FormItem
            control={control}
            name="explaination.explaination_problem"
            type="textarea"
            label={t('problem_to_solve')}
        />

        <FormItem
            control={control}
            name="explaination.explaination_expected"
            type="textarea"
            label={t('customer_expectation')}
        />
    </div>
)

export default StepAdditionalInfo
